<template>
  <v-img :src="innerSrc" @error="onError" />
</template>

<script>
export default {
  name: "BaseImage",

  props: {
    src: {
      type: String,
      default: null,
    },
    default: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      hasError: false,
    };
  },

  computed: {
    innerSrc() {
      if (this.hasError || !this.src) {
        return this.default;
      }

      return this.src;
    },
  },

  methods: {
    onError() {
      this.hasError = true;
    },
  },
};
</script>

<style scoped></style>
